function getCollection() {
    const match = document.cookie.match(/(?:^|;\s*)collection=([^;]*)/);
    return match ? decodeURIComponent(match[1]).split(',').filter(Boolean) : [];
}

function setCollection(ids) {
    const expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = 'collection=' + encodeURIComponent(ids.join(',')) + ';expires=' + expires + ';path=/;SameSite=Lax';
}

function updateNavCount(ids) {
    const span = document.querySelector('.nav-collection-count');
    if (!span) return;
    span.textContent = ids.length > 0 ? ids.length : '';
}

// Initialise nav count on every page
updateNavCount(getCollection());

const el = document.querySelector('.add-to-collection');
if (el) {
    const pageId = el.dataset.pageId;
    const icon  = el.querySelector('.add-to-collection__icon');
    const label = el.querySelector('.add-to-collection__label');

    function update(ids) {
        const saved = ids.includes(pageId);
        icon.textContent  = saved ? '-' : '+';
        label.textContent = saved ? 'Remove from collection' : 'Add to collection';
        el.classList.toggle('is-saved', saved);
        updateNavCount(ids);
    }

    update(getCollection());

    el.addEventListener('click', () => {
        let ids = getCollection();
        if (ids.includes(pageId)) {
            ids = ids.filter(id => id !== pageId);
        } else {
            ids.push(pageId);
        }
        setCollection(ids);
        update(ids);
    });
}
